import React from "react";
import Styles from "./Footer.module.css";
import { useNavigate } from "react-router-dom";
import smileIll from "../../images/smile-illustration.svg";

const Footer = () => {
  const navigate = useNavigate();

  const handleNavigateAbout = () => {
    window.open("https://www.levelfields.ai/about", "_blank");
  };

  const handleNavigateNews = () => {
    window.open("https://fintechnews.levelfields.ai/");
  };

  const navOptions = [
    {
      name: "Home",
      path: "/",
    },
    {
      name: "FAQ",
      path: "/faq",
    },
    {
      name: "Contact us",
      path: "/contact-us",
    },
    {
      name: "About Us",
      func: handleNavigateAbout,
    },
    {
      name: "Blog",
      path: "/blog",
    },
    {
      name: "News",
      func: handleNavigateNews,
    },
    {
      name: "Login",
      path: "/login",
    },
  ];
  return (
    <div className={Styles.Footer}>
      <div className={Styles.LeftText}>
        13G Reports
        <img src={smileIll} alt="smile-illustration" width={30} />
      </div>
      <div className={Styles.RightContent}>
        <ul className={Styles.List}>
          {navOptions.map((item, i) => {
            return (
              <li
                key={i}
                onClick={() => {
                  if (item.path) {
                    return navigate(item.path);
                  } else if (item.func) {
                    return item.func();
                  }
                  return;
                }}
              >
                {item.name}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default Footer;
